import angular from 'angular'
import { PublishActionTime } from '../publishActions/publishActions.dataTypes'
import _ from 'lodash'
import moment from 'moment'
import intl from 'react-intl-universal'

export default ['$filter', '$locale', quickPickInlineHumanize]
function quickPickInlineHumanize($filter, $locale) {
  return (input) => {
    // I wish type checking was a thing.
    if (angular.isUndefined(input) || input === null) {
      return ''
    }
    if (input instanceof PublishActionTime) {
      return input.asTimeCode
    }

    let type = null
    let parsedInput = null
    if (input.constructor === {}.constructor) {
      type = _.get(input, 'type') || 'plain'
      parsedInput = _.get(input, 'time')
    } else if (input.constructor === moment.utc().constructor) {
      parsedInput = input.toDate()
    } else if (input.constructor === new Date().constructor) {
      parsedInput = input
    } else if (angular.isString(input) && input.length === 0) {
      return ''
    } else if (angular.isString(input)) {
      parsedInput = new Date(input)
    } else {
      console.error('Input not supported')
    }
    let before = moment
      .utc()
      .subtract(10, 'minutes')
      .tz(window.org_settings.timezone)
      .toDate()
    let now = moment
      .utc()
      .tz(window.org_settings.timezone)
      .toDate()
    let today = moment
      .utc()
      .add(4, 'minutes')
      .tz(window.org_settings.timezone)
      .toDate()
    if (
      (parsedInput > now && parsedInput < today) ||
      (parsedInput < now && parsedInput > before)
    ) {
      return intl.get('publishActions.publishModal.boltNow')
    }

    if (type === 'planned') {
      return [
        $filter('dateDisp')(
          moment(parsedInput).tz(window.org_settings.timezone),
          $locale.medium
        ),
        `(${intl.get('publishActions.publishModal.boltPlanned')})`,
      ].join(' ')
    }
    return $filter('dateDisp')(
      moment(parsedInput).tz(window.org_settings.timezone),
      $locale.medium
    )
  }
}
